/** Italian formats of the UI. */
import type { IsoDate } from '@k-management/shared';

/** ISO timestamp → "17/09/26, 14:05". */
export function formatTimestamp(value: string): string {
  return new Date(value).toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'short' });
}

/** "2026-09-17" → "17/09/2026". */
export function formatDate(date: IsoDate): string {
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
}

const oneDecimalFormat = new Intl.NumberFormat('it-IT', { maximumFractionDigits: 1 });

/** "850 KB", "2,4 MB". */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${oneDecimalFormat.format(bytes / (1024 * 1024))} MB`;
}

/** Time between two ISO timestamps: "12 s", "3 min". */
export function formatDuration(from: string, to: string): string {
  const seconds = Math.max(0, Math.round((Date.parse(to) - Date.parse(from)) / 1000));
  return seconds < 120 ? `${seconds} s` : `${Math.round(seconds / 60)} min`;
}
